<div class="review">
  <div class="mb-5 hidden items-center space-x-3 lg:flex">
    <span class="mt-1 h-1 w-12 bg-primary-md-dark"></span>
    <h1 class="relative text-2xl font-semibold lg:text-3xl">Review</h1>
  </div>
  <swiper
    class="mySwiper flex space-x-5 text-primary-md-dark"
    [slidesPerView]="'auto'"
    [spaceBetween]="15">
    <ng-template swiperSlide class="w-auto" *ngFor="let nav of navs">
      <button
        type="button"
        class="rounded-md border border-primary-md-dark bg-primary-lightest px-2 py-1 text-sm duration-200 ease-in-out hover:bg-primary-md-dark hover:text-white"
        [routerLink]="[nav.link]"
        routerLinkActive="bg-primary-md-dark text-white">
        {{ nav.name }}
      </button>
    </ng-template>
  </swiper>
  <div class="py-5">
    <router-outlet></router-outlet>
  </div>
</div>
